import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  trialFeaturesContainer: {
    boxSizing: "border-box",
    padding: theme.spacing(4),
    width: "100%",
    height: "100%",
    maxWidth: "480px",
    backgroundColor: theme.palette.blue.dark,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xl")]: {
      maxWidth: "420px",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "100%",
    },
  },
  justifyContent: {
    justifyContent: "flex-end",
    "& > div > .content": {
      padding: "50px 68px",
      [theme.breakpoints.down("md")]: {
        width: "auto",
        padding: theme.spacing(3),
      },
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    },
  },
  companyLogoContainer: {
    width: "165px",
    height: "165px",
    margin: "0 auto",
    marginBottom: 10,
  },
}));
